import types from "rdx/modules/helpjuice/types";
import createAction from "rdx/utils/createAction";

export default {
  getHelpjuiceToken: (payload) => createAction(types.GET_HELPJUICE_TOKEN, payload),
  // INSERTION_PT (for script, do not remove)
};
